/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API56330Req {
  
  /** 任务id */
  taskId?: number;
};



export interface API56330Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 56330 放弃任务

export interface IUsePostAPI56330Return {
  /** 放弃任务: 接口请求状态 */
  isAPI56330Loading: boolean;
  /** 放弃任务: 接口请求返回数据 */
  dataAPI56330: API56330Res;
  /**  放弃任务: 接口数据请求方法 */
  fetchAPI56330Data:  (inputs: API56330Req, config?: YWRequestConfig) => Promise<API56330Res>;
  /** 放弃任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI56330 = ():IUsePostAPI56330Return => {
  let isMount = true;
  const [isAPI56330Loading, setIsAPI56330Loading] = useState(false);
  const [dataAPI56330, setDataAPI56330] = useState<API56330Res>({} as API56330Res);
  const requestUrl = `${basePath}/team-work/workTask/abandonTask`;

  const fetchAPI56330Data = async (inputs: API56330Req, config?: YWRequestConfig): Promise<API56330Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56330Req>) || {}) as API56330Req;
    
  
    if ( isMount ) {
      setIsAPI56330Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API56330Res>(`${basePath}/team-work/workTask/abandonTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI56330(res || {} as API56330Res);
        setIsAPI56330Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56330Loading(false);
      }
      return false as unknown as API56330Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56330Loading,
    dataAPI56330,
    fetchAPI56330Data,
    requestUrl,
  }
}

